<template>
    <div v-if="tieneEditoriales" class="home">
        <editorial @getEditorial="setEditorial" :criterio="this.filtroInicial"></editorial>
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>BUSCADOR</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <filtro :criterio="this.filtroInicial" @buscarEnlaces="buscar" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <listado />
    </div>
    <div v-else>
        <h2>{{mensajeInicial}}</h2>
    </div>
</template>

<script>
    // @ is an alias to /src
    import editorial from '@/components/Editoriales.vue'
    import listado from '@/components/ListadoEnlaces.vue'
    import filtro from '@/components/FiltroEnlaces.vue'
    //import HTTP from '../http-common';
    import { eventHub } from '../http-common/eventhub';
    import { mapState } from 'vuex';

    export default {
        name: 'home',
        components: {
            editorial,
            listado,
            filtro
        },
        data() {
            return {
                mensajeInicial: "Validando acceso a Editoriales."
            }
        },
        computed: {
            ...mapState(['filtroInicial', 'tieneEditoriales'])
        },
        async mounted() {
            await this.cargaDatos();
        },
        //created() {
            
        //},
        methods: {
            buscar(e) {
                this.$store.dispatch('establecerFiltro', e);
                this.$store.dispatch('establecerEnlaces');
            },
            setEditorial(e) {
                this.filtroInicial.idEditorial = e.idEditorial;
                this.buscar(this.filtroInicial);
                this.$store.dispatch('establecerTipos',e.idTipo);
            },
            async cargaDatos() {
                if (!this.tieneEditoriales) {
                    try {
                        let editoriales = await this.$store.dispatch('establecerEditoriales');
                        this.setEditorial(editoriales[0]);
                    } catch (ex) {
                        eventHub.$emit('error', ex)
                    }

                    //HTTP.get('Editoriales')
                    //    .then(response => {
                    //        this.editoriales = response.data;
                    //        if (this.editoriales.length > 0) {
                    //            this.tieneEditoriales = true;
                    //            this.setEditorial(this.editoriales[0].id);
                    //        } else {
                    //            this.mensajeInicial = "No tiene ninguna Editorial Asignada."
                    //        }
                    //    })
                    //    .catch(e => {
                    //        eventHub.$emit('error', e)
                    //    });
                    this.$store.dispatch('establecerEstados');
                }
            }
            //async cargarEditoriales() {
            //    try {
            //        var response = await HTTP.get('Editoriales');
            //        this.editoriales = response.data;
            //        if (this.editoriales.length > 0) {
            //            this.tieneEditoriales = true;
            //            var editorialId = this.editoriales[0].id;
            //            this.filtroInicial.idTipo = editorialId.split("|")[0];
            //            this.filtroInicial.editorial = editorialId.split("|")[1];
            //            this.buscar(this.filtroInicial);
            //            this.cargaTipos(this.filtroInicial.idTipo);
            //        } else {
            //            this.mensajeInicial = "No tiene ninguna Editorial Asignada."
            //        }
            //    }
            //    catch (e) {
            //        eventHub.$emit('error', e)
            //    }
            //}
        }
    }
</script>

<style>
    .v-list-item__content {
        text-align: left;
    }
</style>